import React from 'react'

export const CookieConsumerComponent = ( {children} ) => {
    return <>
        {children}
    </>
}